import { QuestionError } from '@sm/question-definitions';
import { SurveyError } from './types';
import { ErrorType } from './constants';

function transformToSurveyErrors<F extends QuestionError>(errors: F[]): SurveyError[] {
  return errors.map(({ detail, questionId, type }: F) => ({
    questionId,
    detail,
    code: type?.includes('REQUIRED') ? ErrorType.MISSING_REQUIRED_FIELD : ErrorType.INVALID_OPEN_ENDED_VALIDATION,
  })) as SurveyError[];
}

export default transformToSurveyErrors;
